

function DisplayTimeReportState({ state }: { state: number | null | undefined }) {
    switch (state) {
        case 0:
            return (
                <span className="badge bg-danger-subtle text-primary-emphasis rounded-pill">Otvorený</span>
            );
        case 1:
            return (
                <span className="badge bg-warning-subtle text-primary-emphasis rounded-pill">Potvrdený</span>
            );
        case 2:
            return (
                <span className="badge bg-success-subtle text-success-emphasis rounded-pill">Zatvorený</span>
            );
            case 3:
            return (
                <span className="badge bg-primary-subtle text-success-emphasis rounded-pill">Uzamknutý</span>
            );
        default:
            return (
                <span className="badge bg-secondary-subtle text-success-emphasis rounded-pill">Nevytvorený</span>
            )
    }
}

export default DisplayTimeReportState